module.exports = __webpack_public_path__ + "media/images/emblems/Widnau-b6a9dd2d8266eb7719f522082f82b300.png";